export class StoreEventsEnum {

    public static VALIDATION_ERRORS = 'VALIDATION_ERRORS';  // general validation error // TODO: display them in alert?

    // questions
    public static OPEN_EDIT_QUESTION = 'OPEN_EDIT_QUESTION';    // open edit dialog
    public static CLOSE_EDIT_QUESTION = 'CLOSE_EDIT_QUESTION';
    public static EDIT_QUESTION_VALIDATION_ERRORS = 'EDIT_QUESTION_VALIDATION_ERRORS';  // question has validation errors
    public static MOVE_QUESTION = 'MOVE_QUESTION';
    public static OPEN_NEW_QUESTION = 'OPEN_NEW_QUESTION';      // open edit dialog
    public static OPEN_COPY_QUESTION = 'OPEN_COPY_QUESTION';    // open edit dialog
    public static COPY_QUESTION = 'COPY_QUESTION';

    // poll
    public static OPEN_EDIT_POLL = 'OPEN_EDIT_POLL';
    public static CLOSE_EDIT_POLL = 'CLOSE_EDIT_POLL';
    public static EDIT_POLL_VALIDATION_ERRORS = 'EDIT_POLL_VALIDATION_ERRORS';  // poll has validation errors
    public static POLL_RESULTS_DELETED = 'POLL_RESULTS_DELETED';

    public static OPEN_SHARE_POLL = 'OPEN_SHARE_POLL';

    public static POLL_COPIED = 'POLL_COPIED';
    public static POLL_DELETED = 'POLL_DELETED';

    public static EMAILED_RESPONSES_TO_ME = 'EMAILED_RESPONSES_TO_ME';

    public static OPEN_MODAL = 'OPEN_MODAL';
    public static TAKE_POLL = 'TAKE_POLL';  // start taking poll in Author

    // misc events
    public static STORE_ACTION = 'STORE_ACTION';    // used for wiring event to store action

}
